<template>
  <div>
    <div v-show="series.length > 0" class="pa-1 bordered rounded bg-grey_3" id="containerPerDayActivites"></div>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
import Highcharts from "highcharts";
import AdminService from "@/services/admin.service";
export default {
  data() {
    return {
      per_day: {},
      represented_option: [],
      categories: [],
      series: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async get() {
      let res = await AdminService.getStatistiquesActivites(this.mainStore.module.id);
      this.build_data(res);
    },
    build_data(data) {
      if (!data) return;
      this.per_day = {};
      this.represented_option = [];
      let start = this.$moment(this.mainStore.module.date_debut_inscription);
      let end = this.$moment(this.mainStore.module.date_fin_inscription);
      while (start.isBefore(end)) {
        if (!this.per_day[start.format("DD/MM/YYYY")]) {
          this.per_day[start.format("DD/MM/YYYY")] = {};
        }

        start = this.$moment(start).add(1, "day");
      }
      for (let i = 0; i < data.length; i++) {
        if (!this.represented_option.includes(data[i].nom)) {
          this.represented_option.push(data[i].nom);
        }
        let day = this.$moment(data[i].timestamp).format("DD/MM/YYYY");

        if (!this.per_day[day]) {
          this.per_day[day] = {};
        }

        if (!this.per_day[day][data[i].nom]) {
          this.per_day[day][data[i].nom] = 0;
        }
        this.per_day[day][data[i].nom] += parseInt(data[i].quantite);
      }
      this.build_series();
    },
    build_series() {
      this.series = [];
      for (let i = 0; i < this.represented_option.length; i++) {
        let data = [];
        for (let day in this.per_day) {
          this.categories.push(day);
          if (this.$moment(day, "DD/MM/YYYY").isAfter(this.$moment())) {
            break;
          }
          if (this.per_day[day][this.represented_option[i]]) {
            data.push(this.per_day[day][this.represented_option[i]]);
          } else {
            data.push(0);
          }
        }
        let cumulative_data = [0];
        data.forEach(function (elementToAdd, index) {
          var new_element = cumulative_data[index] + elementToAdd;
          cumulative_data.push(new_element);
        });
        cumulative_data.shift();

        this.series.push({
          name: this.represented_option[i],
          data: cumulative_data,
        });
      }
      this.render_graph();
    },
    render_graph() {
      Highcharts.chart("containerPerDayActivites", {
        chart: {
          height: 400,
        },
        title: {
          text: undefined,
          align: "left",
        },
        plotOptions: {
          series: {
            cumulative: true,
            marker: {
              enabled: false,
            },
          },
        },
        xAxis: {
          categories: this.categories,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Inscriptions",
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: "bold",
              color:
                // theme
                (Highcharts.defaultOptions.title.style && Highcharts.defaultOptions.title.style.color) || "gray",
              textOutline: "none",
            },
          },
        },
        legend: {
          align: "left",
          verticalAlign: "top",
          floating: false,
          backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || "white",
          borderColor: "#CCC",
          borderWidth: 1,
          shadow: false,
        },
        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat: "{series.name}: {point.y}",
        },
        series: this.series,
      });
    },
  },
  async created() {
    await this.get();
  },
};
</script>

<style lang="scss" scoped></style>